import { render } from "./StagePickPerspective.vue?vue&type=template&id=6cac8b4a"
import script from "./StagePickPerspective.vue?vue&type=script&lang=js"
export * from "./StagePickPerspective.vue?vue&type=script&lang=js"

import "./StagePickPerspective.vue?vue&type=style&index=0&id=6cac8b4a&lang=scss"
script.render = render

export default script